import axios from 'axios';
const getCompany = id => axios.get(`/companies/${id}`);
const getCompanies = () => axios.get('companies');
const getActivityLogs = ({ companyId, questionnaireId }) =>
  axios.post(`/companies/${companyId}/get_activity_logs`, {
    questionnaire_id: questionnaireId,
  });
const getCompanyIdByHashId = hashId =>
  axios.get(`/companies/get_company_id_by_hash_id?hash_id=${hashId}`);
const getNotificationTypeIds = id =>
  axios.get(`/companies/${id}/get_notification_type_ids`);

const saveNotificationSubscription = ({ entityIds, notificationTypeIds }) =>
  axios.post(`/companies/save_notification_subscription`, {
    entity_ids: entityIds,
    notification_type_ids: notificationTypeIds,
  });

const saveOwnerNotifications = ({ entityId, ownersWithNotifications }) =>
  axios.post(`/companies/${entityId}/save_owner_notifications`, {
    entity_id: entityId,
    owners_with_notifications: ownersWithNotifications,
  });

const getAllExportableDocumentsForEntity = ({ id, year }) =>
  axios.post(
    `/companies/${id}/get_all_exportable_documents_for_entity?year=${year}`,
  );

const createCompany = ({
  entityType,
  companyName,
  userId,
  businessEmail,
  otherEmail,
  ...rest
}) =>
  axios.post('/companies', {
    ...rest,
    ein: 'ein',
    entity_type: entityType,
    name: companyName,
    user_id: userId,
    business_email: businessEmail,
    other_email: otherEmail,
  });

const changePrimaryContact = ({ companyId, newPrimaryContactId }) =>
  axios.post(`companies/${companyId}/change_primary_contact`, {
    new_primary_contact_id: newPrimaryContactId,
  });

const updateOwners = ({
  ownerIds,
  companyId,
  shouldCopyOverPreviousMessages,
  shouldTransferOverPreviousMessages,
}) =>
  axios.post(`/companies/${companyId}/update_owners`, {
    owner_ids: ownerIds,
    should_copy_over_previous_messages: shouldCopyOverPreviousMessages,
    should_transfer_over_previous_messages: shouldTransferOverPreviousMessages,
  });

const createNewOwner = ({
  email,
  firstName,
  lastName,
  phoneNumber,
  companyId,
  groupId,
  shouldCopyOverPreviousMessages,
  shouldTransferOverPreviousMessages,
}) =>
  axios.post(`/companies/${companyId}/create_new_owner`, {
    email,
    fname: firstName,
    lname: lastName,
    phone_number: phoneNumber,
    groupId,
    should_copy_over_previous_messages: shouldCopyOverPreviousMessages,
    should_transfer_over_previous_messages: shouldTransferOverPreviousMessages,
  });

const createSpouseAssigment = ({ userId, companyId }) =>
  axios.post(`/companies/${companyId}/spouse/create_spouse_assignment`, {
    userId,
    companyId,
  });

const createSpouse = ({
  email,
  fname,
  lname,
  phone_number,
  companyId,
  is_taxpayer,
  work_email,
  needsAccess,
}) =>
  axios.post(`/companies/${companyId}/spouse`, {
    email,
    fname,
    lname,
    work_email,
    phone_number,
    is_taxpayer,
    needsAccess,
  });

const getSpouse = companyId => axios.get(`/companies/${companyId}/spouse`);
const updateSpouse = ({ companyId, id, data }) =>
  axios.put(`/companies/${companyId}/spouse/${id}`, data);
const deleteSpouse = ({ companyId, id }) =>
  axios.delete(`/companies/${companyId}/spouse/${id}`);

const updateCompany = ({ id, userId, ...rest }) =>
  axios.patch(`/companies/${id}`, {
    ...rest,
    user_id: userId,
  });
const deleteCompany = id => axios.post(`/companies/${id}/delete_company`);
const submitFeedback = ({ companyId, feedback, pathName }) =>
  axios.post(`/companies/${companyId}/submit_feedback`, {
    feedback,
    path_name: pathName,
  });

const getReferenceId = ({ companyId }) =>
  axios.get(`/companies/${companyId}/get_reference_id`);

const updateTags = ({ companyId, entityTags }) => {
  return axios.post(`/companies/${companyId}/update_tags`, {
    company_id: companyId,
    entity_tags: entityTags,
  });
};

const updateTagsInBulk = ({ companyIds, selectedTags, remove }) => {
  return axios.post(`/companies/update_tags_in_bulk`, {
    company_ids: companyIds,
    selected_tags: selectedTags,
    remove,
  });
};

export default {
  getCompany,
  saveOwnerNotifications,
  getCompanyIdByHashId,
  getCompanies,
  createCompany,
  updateCompany,
  submitFeedback,
  deleteCompany,
  createNewOwner,
  createSpouse,
  createSpouseAssigment,
  updateSpouse,
  deleteSpouse,
  getSpouse,
  updateOwners,
  getActivityLogs,
  changePrimaryContact,
  getNotificationTypeIds,
  saveNotificationSubscription,
  getReferenceId,
  updateTags,
  updateTagsInBulk,
  getAllExportableDocumentsForEntity,
};
